module.exports = __webpack_public_path__ + "img/solution-25d1.6106d62e.png";